var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFireIcon = function SvgFireIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fire-icon_svg__a)",
    d: "M12.652 4.162c-.812-1.3-1.869-2.419-2.787-3.337a.5.5 0 0 0-.438-.138.5.5 0 0 0-.369.275l-1.931 4.05-2.013-1.344a.51.51 0 0 0-.555 0 .5.5 0 0 0-.138.138c-1.219 1.837-1.838 3.5-1.838 4.944a5.75 5.75 0 1 0 11.5 0c0-1.557-.469-3.057-1.431-4.588m-.612 5.163a3.725 3.725 0 0 1-3.132 3.13h-.075a.5.5 0 0 1-.075-.993 2.775 2.775 0 0 0 2.294-2.294.5.5 0 1 1 .988.15z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "fire-icon_svg__a",
    x1: 8.333,
    x2: 8.333,
    y1: 0.68,
    y2: 14.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC23C"
  })))));
};
export default SvgFireIcon;